/* global G */
import { get, resolve } from 'lib/manager/acl/helper'
import { _defaultAclProps } from 'lib/manager/acl/api/component'

/**
 * Hide by context
 *
 * @param {Gaia.Web.Application} obj - native application
 * @returns {function(*=): (*)}
 */
const fn = obj => (item) => {
  if (!item.aclContext) return {}

  const aclContext = resolve({
    [G.ACL]: { context: item.aclContext },
    [G.CONFIGURATION]: item.aclProps ? { aclProps: item.aclProps } : _defaultAclProps,
  })

  try {
    get(obj)[G.API].check(
      [obj[G.SESSION][G.STATE][G.CONTEXT]],
      aclContext[G.ACL],
    )
  } catch (e) {
    return aclContext[G.PROPS]
  }
  return {}
}

export default fn
